export default function <T>(value: T[] | T): value is T[] {
  if (Array.isArray(value)) {
    return true;
  } else {
    return false;
  }
}
